import { createWebHistory, createRouter } from "vue-router";

// All Pages
import HomePageBenovium from "../components/Pages/HomePageBenovium";
import AboutPage from "../components/Pages/AboutPage";
import PricingPage from "../components/Pages/PricingPage";
import ServicesPageTwo from "../components/Pages/ServicesPageTwo";
import ServicesPageThree from "../components/Pages/ServicesPageThree";
import ServicesDetailsPage from "../components/Pages/ServicesDetailsPage";
import FeaturesPageOne from "../components/Pages/FeaturesPageOne";
import FeaturesPageTwo from "../components/Pages/FeaturesPageTwo";
import TeamPage from "../components/Pages/TeamPage";
import LoginPage from "../components/Pages/LoginPage";
import SignupPage from "../components/Pages/SignupPage";
import FaqPage from "../components/Pages/FaqPage";
import BlogPageOne from "../components/Pages/BlogPageOne";
import BlogPageTwo from "../components/Pages/BlogPageTwo";
import BlogDetailsPage from "../components/Pages/BlogDetailsPage";
import ContactPage from "../components/Pages/ContactPage";

// Service Detail Pages
import WebentwicklungPage from "../components/Pages/WebentwicklungPage";
import SeoPage from "../components/Pages/SeoPage";
import BetreuungPage from "../components/Pages/BetreuungPage";
import ItBeratungPage from "../components/Pages/ItBeratungPage";

// Legal Pages
import ImpressumPage from "../components/Pages/ImpressumPage";
import DatenschutzPage from "../components/Pages/DatenschutzPage";

// Referenzen
import ReferenzenPage from "../components/Pages/ReferenzenPage";

const routes = [
  { path: "/", component: HomePageBenovium },
  // { path: "/home-two", component: HomePageTwo },
  // { path: "/home-three", component: HomePageThree },
  // { path: "/home-four", component: HomePageFour },
  // { path: "/home-five", component: HomePageFive },
  // { path: "/home-six", component: HomePageSix },
  // { path: "/home-seven", component: HomePageSeven },
  // { path: "/home-eight", component: HomePageEight },
  // { path: "/home-nine", component: HomePageNine },
  // { path: "/home-ten", component: HomePageTen },
  // { path: "/home-eleven", component: HomePageEleven },
  { path: "/about", component: AboutPage },
  { path: "/pricing", component: PricingPage },
  { path: "/services", component: ServicesPageTwo },
  // { path: "/services-two", component: ServicesPageTwo },
  { path: "/services-three", component: ServicesPageThree },
  { path: "/service-details", component: ServicesDetailsPage },
  { path: "/services/webentwicklung", component: WebentwicklungPage },
  { path: "/services/seo", component: SeoPage },
  { path: "/services/betreuung", component: BetreuungPage },
  { path: "/services/it-beratung", component: ItBeratungPage },
  { path: "/features", component: FeaturesPageOne },
  // { path: "/features-two", component: FeaturesPageTwo },
  // { path: "/team", component: TeamPage },
  // { path: "/log-in", component: LoginPage },
  // { path: "/sign-up", component: SignupPage },
  { path: "/faq", component: FaqPage },
  // { path: "/blog-one", component: BlogPageOne },
  // { path: "/blog-two", component: BlogPageTwo },
  // { path: "/single-blog", component: BlogDetailsPage },
  { path: "/contact", component: ContactPage },
  { path: "/referenzen", component: ReferenzenPage },
  { path: "/impressum", component: ImpressumPage },
  { path: "/datenschutz", component: DatenschutzPage },
];

const router = createRouter({
  history: createWebHistory(),
  linkExactActiveClass: "active",
  routes,
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
});

export default router;
